import { IonContent, IonPage, IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { dashboardPageStyle } from '../../Layout';
import PageTitle from '../../../../components/Dashboard/PageTitle';
import LayoutNav from '../../../../components/Dashboard/settings/ui/LayoutNav';
import { Redirect, Route, RouteComponentProps } from 'react-router';
import ContactInformationPage from './pages/ContactInformationPage';
import ComingSoonPage from '../ComingSoonPage';
const navLinks = [
  {
    label: 'Active disputes',
    to: '/dashboard/help&support/active-disputes',
  },
  {
    label: 'Contact Support',
    to: '/dashboard/help&support/contact-support',
  },
];

export default function index({ match }: RouteComponentProps) {
  return (
    <IonPage>
      <IonContent>
        <div className={`${dashboardPageStyle} pr-2 h-full flex flex-col`}>
          <div className="space-y-2">
            <PageTitle>Customer Disputes & Resolutions</PageTitle>
            <p className="medium-emphasis-text">
              We're here to help you with any questions or issues
            </p>
            <div className="w-full">
              <LayoutNav navLinks={navLinks} />
            </div>
          </div>
          <div className="relative flex-1 ">
            <IonRouterOutlet>
              <Route
                path={`${match.path}/active-disputes`}
                exact
                // component={ActiveDisputesPage}
                render={() => <ComingSoonPage title="Active Disputes" />}
              />
              <Route
                path={`${match.path}/contact-support`}
                exact
                component={ContactInformationPage}
              />
              <Redirect
                to={`${match.path}/active-disputes`}
                exact
                from={match.path}
              />
            </IonRouterOutlet>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
